import * as React from 'react';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import weekOfYear from 'dayjs/plugin/weekOfYear'
import { styled } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import buddhistEra from "dayjs/plugin/buddhistEra";
import advancedFormat from "dayjs/plugin/advancedFormat"
import 'dayjs/locale/th';

dayjs.extend(buddhistEra);
dayjs.extend(advancedFormat)
dayjs.locale("th");
dayjs.extend(isBetweenPlugin);
dayjs.extend(weekOfYear)

dayjs.extend(updateLocale)

dayjs.updateLocale('th', {
    weekStart: 0,
    yearStart: 7
})

const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'isHovered',
})(({ theme, isSelected, isHovered, day }) => ({
    borderRadius: 0,
    ...(isSelected && {
        backgroundColor: `#b73238 !important`,
        color: `${theme.palette.primary.contrastText} !important`,
        '&:hover, &:focus': {
        backgroundColor: `#b73238 !important`,
        },
    }),
    ...(isHovered && {
        backgroundColor: `#ffebee !important`,
        '&:hover, &:focus': {
        backgroundColor: `#ffebee !important`,
        },
    }),
    ...(day.day() === 0 && {
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
    }),
    ...(day.day() === 6 && {
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
    }),
}));

const isInSameWeek = (dayA, dayB) => {
  if (dayB == null) {
    return false;
  }

  return dayA.isSame(dayB, 'week');
};


function Day(props) {
    const { day, selectedDay, hoveredDay, ...other } = props;
    return (
        <CustomPickersDay
        {...other}
        day={day}
        sx={{ px: 2.5}}
        disableMargin
        selected={false}
        isSelected={isInSameWeek(day, selectedDay)}
        isHovered={isInSameWeek(day, hoveredDay)}
        />
    );
}

export default function EPWeekPicker(props) {
    const [hoveredDay, setHoveredDay] = React.useState(null);

    const shortcutsItems = [
        {
            label: 'สัปดาห์แรกของปี',
            getValue: () => {
              return dayjs().week(1)
            },
        },
        {
            label: 'สัปดาห์ปัจจุบัน',
            getValue: () => {
              const today = dayjs();
              return today.day(0)
            },
        },
    ]

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th" dateFormats={{ monthAndYear: 'MMMM BBBB', year: 'BBBB' }} 
            localeText={{
                calendarWeekNumberHeaderText: 'สัปดาห์',
                calendarWeekNumberText: (weekNumber) => `${weekNumber}.`,
            }}
        >
        <DatePicker {...props}
            showDaysOutsideCurrentMonth
            displayWeekNumber
            dayOfWeekFormatter={(_day, weekday) => `${weekday.format('dd')}`}
            slots={{ day: Day}}
            slotProps={{
                textField: { size: 'small', inputProps:{value: `${props.value.format('ww/BBBB')}`}},
                shortcuts:{
                    items: shortcutsItems,
                },
                day: (ownerState) => ({
                    selectedDay: props.value,
                    hoveredDay,
                    onPointerEnter: () => setHoveredDay(ownerState.day),
                    onPointerLeave: () => setHoveredDay(null),
            }),
            }}
        />
        </LocalizationProvider>
    );
}